import { App } from "@capacitor/app";
import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import useUserAction from "../../../hooks/user/useUserAction";

const AppUrlListener = () => {
	let history = useHistory();
	const {userLogin, userLogout} = useUserAction()
	useEffect(() => {
		App.addListener('appUrlOpen', (event) => {
			// Extract the path (after the scheme)
			const url = event.url;
			if(url.includes('logout')) {
				const path = url.replace('gr.periferia.transports://logout', '/').split('?')[0];
				if (path) {
					userLogout()
				}
			} else if(url.includes('login')) {
				const path = url.replace('gr.periferia.transports://login', '/').split('?')[0];
				// Extract query params (if any)
				const queryParams = new URLSearchParams(url.split('?')[1]);
				// Now, you can get individual query params like this
				const username = queryParams.get('username');
				if (path) {
					const values = { username: username, password: 'mpla', aade: 1}
					userLogin(values)
				}
				// If no match, do nothing - let regular routing
				// logic take over
			}
		})
		
		return () => {
			App.removeAllListeners()
		}
	}, [history, userLogin, userLogout]);
	
	return null;
};

export default AppUrlListener